<!--
 * @Author: tracy.sun
 * @Date: 2020-12-02 18:05:47
 * @LastEditors: tracy.sun
 * @LastEditTime: 2022-03-18 11:00:39
 * @Description:
-->
<template>
  <div class="no-page">
    <div class="empty-data">
      <div class="page-empty" >
        <img src="@/assets/images/empty@2x.png"/>
      </div>
      <p>暂无页面权限</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.no-page {
  position: relative;
  height: calc(100% - 48px);
  .empty-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    .page-empty {
      width: 118px;
      height: 116px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      font-size: 14px;
      color: #cbd5ee;
      line-height: 20px;
      margin-top: 20px;
    }
  }
}
</style>
